import React, { useEffect, useState, version } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const ManageUsers = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [downloadusers, setDownloadusers] = useState([]);
  const [fileheaders, setFileheaders] = useState([]);

  const [masters, setMasters] = useState({});
  const [totalcount, setTotalcount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [ispreparedownload, setIspreparedownload] = useState(false);

  const [filterparams, setFilterparams] = useState({
    offset: 0,
    size: rowsPerPage
  });
  const { sendNetworkRequest } = React.useContext(NetworkContext);

 function onFilter(filterobj)
  {
    setOrders([])
    setFilterparams({
      ...filterparams,
        offset : 0,
      ...filterobj
    })
  }
  function onSearch(searchtext)
  {
    setOrders([])
    setFilterparams({
      ...filterparams,
      searchtext
    })
  }
  async function onPreparedownload()
  {
   let bodyparams = {
    ...filterparams,
    size : null,
    offset : 0
   }
   let adminusers = await sendNetworkRequest('/admin/fetchuserdownload', {}, bodyparams,false)
   setIspreparedownload(true)
   setDownloadusers([...adminusers?.rows])
   if(adminusers?.rows?.length > 0)
   {
    setFileheaders(Object.keys(adminusers?.rows[0]))
   }
   
  }
  useEffect(() => {
    fetchmasters()
  //  setOrders([{
  //   name: "manokaran",
  //   mobile: "8148647067",
  //   city : "Chennai",
  //   customergroup : "Company",
  //   companyname: "SM Infotech",
  //   platform: "android",
  //   version : "1.48",
  //   status : "Active"

  //  }])
  }, []) 

  useEffect(() => {
    
      fetchadminusers()
  }, [filterparams]) 
  async function fetchadminusers()
  {
    let adminusers = await sendNetworkRequest('/admin/fetchappusers', {}, filterparams,false)
    setTotalcount(adminusers?.rows?.count)
    if(filterparams.offset > 0)
    {
      setOrders([...orders,...adminusers?.rows?.rows])
    }else
    {
      setOrders([])
      setOrders([...adminusers?.rows?.rows])

    }
    

  }
  function handlepagelimit(limit)
  {
    setOrders([])
    setRowsPerPage(limit)
    setFilterparams({
      ...filterparams,
      size : limit
    })
  }
  function handlepagechange(page)
  {
    if(filterparams.offset < page)
    {
      setFilterparams({
        ...filterparams,
        offset : page
      })
    }
   

  }

  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let master_commodities = []
    let comm =  commodities?.module
    comm.map((item,index) => {
      master_commodities.push( {
        value : item?.id,
        label : item?.name
      })
    })
    let languages = await sendNetworkRequest('/admin/fetchmasterlanguage', {}, {},false)
    let master_languages = []
    languages.map((item,index) => {
      master_languages.push( {
        value : item?.id,
        label : item?.name
      })
    })
    let usertypes = await sendNetworkRequest('/admin/fetchusertype', {}, {},false)

    setMasters({
      ...masters,
      commodity : master_commodities,
      languages : master_languages,
      usertypes : usertypes
    })
  }

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
       <UserFilter masters={masters} onPrepare={onPreparedownload} onSearch={onSearch} isreadyfordownload={ispreparedownload} onFilter={onFilter} data={downloadusers} headervalues={fileheaders}/> 
      <Results
        className={classes.results}
        orders={orders} //
        totalcount={totalcount}
        rowsPerPage={rowsPerPage}
   
        onPagechange={handlepagechange}
        onPagelimit={handlepagelimit}
      />
     
    </Page>
  );
});

export default ManageUsers;
